import { forwardRef } from "react";
import DateTimePicker, { PICKER_MODE } from "./DateTimePicker";
import { DateFormatType } from "interfaces/models/inspectionItemResult";

interface Props {
  formatType: DateFormatType;
  isReadOnly?: boolean;
  value: Date | string | undefined | null;
  placeholderText?: string;
  showIcon?: boolean;
  isLoading?: boolean;
  isShowCalendar?: boolean;
  inputStyle?: React.CSSProperties;
  isShowTooltip?: boolean;
  clearIconFontSize?: string;
  setIsShowCalendar: (val: boolean) => void;
  onChangeStatusValidDate?: (val: boolean) => void;
  onChange:
    | ((
        value?: string | Date | null | undefined
      ) => Promise<boolean | undefined>)
    | undefined;
}

export interface DatePickerRef {
  focusInput: () => void;
}

const DatePicker = forwardRef<DatePickerRef, Props>((props: Props, ref) => {
  const { onChangeStatusValidDate, ...restProps } = props;
  
  return (
    <DateTimePicker
      mode={PICKER_MODE.DATE}
      ref={ref}
      {...restProps}
      onChangeStatusValid={onChangeStatusValidDate}
    />
  );
});

export default DatePicker;
